<div class="responsive-card">
  <div class="d-flex gap-2 flex-column mb-4">
    <div class="responsive-card-title" i18n>Recurring Payment Details</div>
    <div *ngIf="isMandatoryRetirement" class="d-flex gap-1 align-items-center">
      <img class="tooltip-img" [src]="'assets/icons/grey/CircleExclamationMark.svg'" alt="question-mark" i18n-alt />
      <div class="info" i18n>Mandatory Retirement</div>
    </div>
  </div>
  <div class="d-flex gap-3 flex-column">
    <app-variable-benefit-recurring-payment-details-card
      *ngIf="!!monthlyRecurringPaymentForm"
      header="Monthly Payment"
      i18n-header
      [recurringPaymentForm]="monthlyRecurringPaymentForm"
      [isMemberPortal]="isMemberPortal" />
    <app-variable-benefit-recurring-payment-details-card
      *ngIf="!!annualRecurringPaymentForm"
      header="Annual Payment"
      i18n-header
      [recurringPaymentForm]="annualRecurringPaymentForm"
      [isMemberPortal]="isMemberPortal" />
  </div>
</div>
